import { useParams } from 'react-router-dom';
import DealGrid from './DealGrid';
import LoadingSpinner from '../common/LoadingSpinner';
import NotFound from '../common/NotFound';
import { useCategoryPage } from '../../hooks/useCategoryPages';

/**
 * /category/:slug — the deal grid for one category, with its own heading, title
 * and canonical URL. The server answers unknown slugs with a 404 (lib/pageRoutes.js),
 * and so does this component after in-app navigation.
 */
const CategoryLanding = () => {
  const { slug } = useParams();
  const { category, loaded } = useCategoryPage(slug);

  if (category) {
    // key: switching category remounts the grid so it loads the new category
    return <DealGrid key={category.slug} landing={category} />;
  }
  return loaded ? <NotFound /> : <LoadingSpinner />;
};

export default CategoryLanding;
